import { selectorFamily } from 'recoil';

import { getDataset, getDatasets } from 'src/api/dataset';
import { Modality } from 'src/types/api/data/image';

type DatasetProps = {
  id: string;
  modality: Modality;
};

const dataset = selectorFamily({
  key: 'dataset/dataset',
  get:
    ({ id, modality }: DatasetProps) =>
    async () => {
      if (modality && id) {
        return getDataset(id, modality);
      }
    },
});

type DatasetsProps = {
  page?: number;
  modality: Modality;
  projectId?: string;
};

// there is no way to get all of datasets from the first api call.
// so, this is just a magic number
const datasetPageSize = 1000;

const allDataset = selectorFamily({
  key: 'dataset/allDataset',
  get:
    ({ modality, projectId }: DatasetsProps) =>
    async () => {
      const datasetsInfo = await getDatasets(
        modality,
        projectId,
        1,
        datasetPageSize
      );

      const { datasets, countTotalPages } = datasetsInfo;

      if (countTotalPages > 1) {
        const pages = Array(countTotalPages - 1)
          .fill(null)
          .map((_, i) => i + 2);
        const result = await Promise.all(
          pages.map(p => getDatasets(modality, projectId, p, datasetPageSize))
        );

        return [...datasets, ...result.flatMap(d => d.datasets)];
      }

      return datasets;
    },
});

const allDatasetOptionList = selectorFamily({
  key: 'dataset/allDatasetOptionList',
  get:
    ({ modality, projectId }: DatasetsProps) =>
    async ({ get }) => {
      const datasetList = get(allDataset({ modality, projectId }));
      if (datasetList)
        return datasetList.map(ds => {
          return {
            value: ds.id || '',
            label: ds.name,
          };
        });
      else return [];
    },
});

export const datasetState = Object.freeze({
  dataset,
  allDataset,
  allDatasetOptionList,
});
